export default __webpack_public_path__ + "static/media/1027.ab54220b.png";